export default __webpack_public_path__ + "a553f18e1958a52ed2baf122348e868c.png";